import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { FolderPlus2 } from 'blaze-ui/icons'
import { useModals } from 'almanac-ui/Modal'
import { NewProjectModal } from 'components/BlazeCommandLine/modals/NewProjectModal'
import { IconProps } from 'blaze-ui/icons/Types'
import { PressProps } from '@react-aria/interactions'
import { forwardRef } from 'react'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import Styles from './AllFiles.module.scss'
import { useRootStore } from 'stores/RootStore'
import cx from 'classnames'
import { observer } from 'mobx-react-lite'

type Props = Pick<PressProps, 'onPress'> & { iconSize?: number; color?: string }

export const NewProjectIconButton = observer(
  forwardRef<HTMLButtonElement, Props>(({ onPress, iconSize, color, ...props }, fRef) => {
    const { leftSidebarStore: sidebarStore } = useRootStore()

    return (
      <IconButton
        className={cx(Styles.newProjectButton, { [Styles.isSidebarHovered]: sidebarStore.isHovered })}
        ref={fRef}
        icon={({ size }: Pick<IconProps, 'size'>) => (
          <FolderPlus2 color={color ?? 'var(--selected-fill)'} size={iconSize ?? size} />
        )}
        onPress={onPress}
        variant="ghost"
        size="xs"
        {...props}
        aria-label="New Project"
      />
    )
  }),
)

export const NewProjectButton = () => {
  const isRedesign = useIsSystemRedesign()
  const { openModal } = useModals()

  const handlePress = () => {
    openModal(NewProjectModal)
  }

  return <NewProjectIconButton onPress={handlePress} color={isRedesign ? 'var(--dark-60)' : 'var(--selected-fill)'} />
}
